import React from "react"
import { Col, Row } from "react-bootstrap"
import { State, useHookstate } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { useLanguageState } from "../../globalStates/LanguageState"
import { Organization } from "../../globalStates/ExhibitorDataTypes"
import { getElementFieldValue } from "../../globalStates/utils"
import Section from "../../components/Section"
import TextField from "../../components/Field/Text"

interface CompanyNameSectionProps {
    organizationState: State<Organization, Validation>
}

const CompanySortSection: React.FC<CompanyNameSectionProps> = ({ organizationState }) => {
    const branding = useLanguageState().getStrings()
    const organization = useHookstate(organizationState)

    return (
        <Section id="companySort" title={branding.configuration.printPage.sctCompanySort.lblSectionCompanySort}>
            <Row>
                <Col>
                    <TextField
                        id="sortName"
                        name="sortName"
                        label={branding.configuration.printPage.sctCompanySort.lblCompanySort}
                        value={getElementFieldValue(organization, "sortName")}
                        readonly
                    />
                </Col>
            </Row>
        </Section>
    )
}

export default CompanySortSection
